import { Box, Typography } from "@mui/material"
import { CheckCircleFilledRounded } from "@mui-symbols-material/w300"
import type { FC } from "react"

import type { NewRequestFormValues } from "../../types"

interface ConfirmedHeaderSummaryProps {
  formValues: Partial<NewRequestFormValues>
}

export const ConfirmedHeaderSummary: FC<ConfirmedHeaderSummaryProps> = ({ formValues }) => {
  const requesterNames = formValues.requesters
    ?.map((requester) => `${requester.firstName} ${requester.lastName}`)
    .join(", ")

  return (
    <Box className='flex flex-col gap-2 rounded border border-gray-300 p-3'>
      {formValues.customer && (
        <Box className='flex items-center gap-3'>
          <CheckCircleFilledRounded className='shrink-0 text-green-600' />
          <Typography className='text-sm text-gray-700'>
            {formValues.customer.company.name}
            {formValues.customer.billingLocation.name && ` - ${formValues.customer.billingLocation.name}`}
          </Typography>
        </Box>
      )}
      {requesterNames && (
        <Box className='flex items-center gap-3'>
          <CheckCircleFilledRounded className='shrink-0 text-green-600' />
          <Typography className='text-sm text-gray-700'>{requesterNames}</Typography>
        </Box>
      )}
    </Box>
  )
}
